export default {
  name: "ProblemSection",

  data() {
    return ({
      problem_data: {
        kicker: "The Problem",
        title: "The Structural Crisis Meets Inefficient Capital",
        description:
          "South Africa creates dependency because we fund relief. We need a model that creates taxpayers. We must make donations investable.",
        stat_value: "46.1%",
        stat_label: "Youth Unemployment (Ages 15–34)",
        cards: [
          {
            kicker: "Linear Funding — The Old Model",
            text:
              'Money is consumed and exits the system, creating a "Social Grant Trap" where support costs outpace the productive tax base.',
            flow: "Donation → Consumption → Ø",
          },
          {
            kicker: "Circular Funding — The New Model",
            text:
              "Capital purchases assets that generate revenue. A profit share recycles back into the fund to capitalize the next entrepreneur.",
            flow: "Capital → Asset → Revenue → Reinvest → ↻",
          },
        ],
      },
    });
  },
};
